import classnames from 'classnames';
import { FunctionComponent } from 'react';

type CartProps = {
    className?: string;
};

const Cart: FunctionComponent<CartProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'cart'}
            viewBox="0 0 250 250"
        >
            <path d="M108.3 184.2c-9.3 0-16.8 7.5-16.8 16.8s7.5 16.8 16.8 16.8 16.8-7.5 16.8-16.8-7.5-16.8-16.8-16.8zm0 24.6c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8zM190 184.2c-9.3 0-16.8 7.5-16.8 16.8s7.5 16.8 16.8 16.8 16.8-7.5 16.8-16.8-7.5-16.8-16.8-16.8zm0 24.6c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8zM241 69.9L217.2 158H81L48.9 34.4c-.5-2-2.3-3.4-4.4-3.4H.3v9h40.8l32.1 123.6c.5 2 2.3 3.4 4.4 3.4h143.1c2 0 3.8-1.4 4.3-3.3l24.7-91.4-8.7-2.4z" />
        </svg>
    );
};

export default Cart;
